import React from 'react'

const Spinner = () => {
  return (
    <div className='h-screen w-full flex justify-center items-center'>

      <div className='spinner'>  
      </div>

    </div>
    
  )
}

export default Spinner;
